import type { ISbRichtext } from "storyblok-js-client";

const isEmpty = (richtext: ISbRichtext) => {
  const { content } = richtext || {};

  if (!content) {
    return true;
  }

  if (content.length === 0) {
    return true;
  }

  if (content.length === 1 && !Object.prototype.hasOwnProperty.call(content[0], "content")) {
    return true;
  }

  return false;
};

export default isEmpty;
